module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-03@3x-47db4b961c1a127a95ceff3bb7ca8e83.png";